<script>
  export default {
    props: {
      parKey: Number,
      paragraph: Object,
      selectedClassName: {
        type: String,
        default: ''
      },
      noOfSelectedSentences: {
        type: Number,
        required: true
      }
    },
    computed: {
      paragraphType () {
        const lastDashPosition = this.paragraph.type.lastIndexOf('-') + 1;
        return this.paragraph.type.substring(lastDashPosition)
      }
    },
    render: function (createElement) {
      const paragraph = this.paragraph.content ? this.paragraph.content.replace(/\. /g, '. {{new_sentence}}') : '';
      const sentences = paragraph.split('{{new_sentence}}');
      let sentencesElementArray = [];
      sentences.map((sentence, i) => {
        sentencesElementArray.push(createElement('span', {
          class: { [this.selectedClassName]: this.noOfSelectedSentences === -1 || this.noOfSelectedSentences >= i+1 },
          domProps: { innerHTML: sentence }
          },
        sentence))
      });

      return createElement(
        this.paragraphType, {
          class: 'editor-content',
          attrs: {
            id: 'editor-content-' + this.parKey
          }
        },
        sentencesElementArray
      )
    }
  }
</script>